<template>
    <div class="contact-widget" ref="zendesk-container">
        <div class="contact-widget-title">
            <strong>Contact Us</strong>
            <button class="btn btn-sm" @click.prevent="hide" type="button">
                Close
            </button>
        </div>
        <div class="contact-widget-body">
            <div class="text-center mt-100" v-if="sent">
                <strong class="font f-w-700">Thanks for reaching out</strong>
                <p class="font f-w-300">
                    Someone will get back to you soon
                </p>

                <button @click="showForm" class="btn bg-color white color brand-r-500 font f-w-400">
                    Go Back
                </button>
            </div>
            <form class="row mx-0 form-widget" id="form-widget" @submit.prevent="submit" autocomplete="off" v-if="!sent">
                <div class="form-group col-md-12 mb-24">
                    <!-- The inputs below are for preventing hubspot from tracking this form -->
                    <label for="amex" class="d-none">AMEX</label>
                    <input type="hidden" class="d-none" name="amex" required="" value="" id="amex">
                    <label for="cc-num" class="d-none">credit card HubspotCollectedFormsWorkaround</label>
                    <input name="cc-num" class="d-none" required="" value="HubspotCollectedFormsWorkaround" id="cc-num">

                    <label class="font f-w-700 f-s-14 l-h-20 f-w-600 mb-8 color primary required">Name</label>
                    <input
                        readonly
                        @focus="writeable"
                        type="text"
                        name="name"
                        class="font roboto-regular color black-0 f-s-14 form-control"
                        :class="{ 'is-invalid': errors.first('name')}"
                        v-validate="'required'"
                        v-model="form.name"
                    >
                    <div class="invalid-feedback" v-if="errors.first('name')">
                        {{ errors.first('name') }}
                    </div>
                </div>
                <div class="form-group col-md-12 mb-24">
                    <label class="font f-w-700 f-s-14 l-h-20 f-w-600 mb-8 color primary required">Email</label>
                    <input
                        readonly
                        @focus="writeable"
                        type="text"
                        name="email"
                        class="font roboto-regular color black-0 f-s-14 form-control"
                        :class="{ 'is-invalid': errors.first('email')}"
                        v-validate="'required|email'"
                        v-model="form.email"
                    >
                    <div class="invalid-feedback" v-if="errors.first('email')">
                        {{ errors.first('email') }}
                    </div>
                </div>
                <div class="form-group col-md-12 mb-24">
                    <label
                        class="font f-w-700 f-s-14 l-h-20 f-w-600 mb-8 color primary required"
                    >Phone Number</label>
                    <input
                        readonly
                        @focus="writeable"
                        type="text"
                        name="phone"
                        class="font roboto-regular color black-0 f-s-14 form-control"
                        :class="{ 'is-invalid': errors.first('phone') }"
                        v-model="form.phone"
                        v-validate="'required'"
                    >
                    <div class="invalid-feedback" v-if="errors.first('phone')">
                        {{ errors.first('phone') }}
                    </div>
                </div>

                <div class="form-group col-md-12 mb-24">
                    <label class="font f-w-700 f-s-14 l-h-20 f-w-600 mb-8 color primary required">How can we help you?</label>
                    <textarea
                        readonly
                        @focus="writeable"
                        type="text"
                        name="message"
                        class="font roboto-regular color black-0 f-s-14 form-control form-message"
                        :class="{ 'is-invalid': errors.first('message')}"
                        v-validate="'required'"
                        v-model="form.message"
                    />
                    <!-- <div class="invalid-feedback  d-flex justify-content-between align-items-center">
                        <span>{{ errors.first('message') }}</span>
                        <span>
                            <span class="color red-0 font roboto-bold f-s-14">{{ messageLength }} / {{ messageMaxLength }}</span>
                        </span>
                    </div> -->
                </div>
                <div class="form-group col-md-12 mb-24">
                    <drop-zone
                        max-file="3"
                        ref="dropzone"
                    />
                </div>
            </form>
        </div>
        <div class="contact-widget-footer" v-if="!sent">
            <button
                form="form-widget"
                type="submit"
                class="btn primary sm font f-w-700 f-s-16 l-h-24 d-inline-flex align-items-center"
            >
                <span
                    ref="loading"
                    class="lottie-loading"
                    v-show="loading"
                />
                <span v-show="!loading">Send</span>
            </button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import each from 'lodash/each';
import get from 'lodash/get';
import DropZone from '~/components/common/input/dropzone/index';
import lottie from 'lottie-web';
import loadingAnimation from '~/lottie/loading.json';

const formDefault = function() {
    return {
        name: '',
        email: '',
        phone: '',
        message: '',
        subject: 'Test Subject',
    };
};

Vue.directive('zendesk-widget', {
    inserted: function (el, binding, vnode, oldVnode) {
        el.onclick = function() {
            const widget = document.querySelector('.contact-widget');
            widget.classList.add('show');
        };
    },
});

export default {
    components: {
        DropZone,
    },
    data() {
        return {
            loading: false,
            sent: false,
            form: formDefault(),
            files: [],
        };
    },
    computed: {
        phone() {
            return get(this.$route, 'query.phone', '');
        },
        name() {
            return get(this.$route, 'query.name', '');
        },
        email() {
            return get(this.$route, 'query.email', '');
        },
    },
    mounted () {
        const { phone, email, name } = this;

        this.form = Object.assign({}, formDefault(), { email, phone, name });

        lottie.loadAnimation({
            container: this.$refs.loading,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: loadingAnimation,
        });
    },
    methods: {
        writeable(e) {
            e.target.readOnly = false;
        },
        hide() {
            this.$refs['zendesk-container'].classList.remove('show');
        },
        showForm() {
            this.sent = false;
        },
        async submit() {
            try {
                const formData = new FormData();

                this.loading = true;
                let form = this.form;
                let subject = 'Website';
                const formUrl = '/v1/zendesk-widget';
                const validate = await this.$validator.validate();

                if (!validate) return;
                switch (this.$device.type) {
                case 'apple':
                case 'android':
                case 'mobile':
                    subject = `Mobile Application (${this.$device.apple ? 'iOS' : 'Android'})`;
                    break;

                default:
                    subject = 'Website Contact Us';
                    break;
                }

                form = Object.assign({}, form, { subject });

                each(form, (value, key) => {
                    formData.append(key, value);
                });

                const files = this.$refs.dropzone.getFiles();
                each(files, (file, key) => {
                    formData.append('files', file);
                });

                await this.$axios.$post(formUrl, formData);

                this.form = formDefault();
                this.errors.clear();
                this.$validator.reset();
                this.sent = true;
            } catch (error) {} finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss">
@import '~/assets/styles/theme/_vars.scss';

.contact-widget {
    @media (max-width: 576px) {
        max-width: 100%;
        width: 100%;
        height: 100%;
        right: 0px;
        bottom: 0px !important;
    }

    .lottie-loading {
        display: block;
        width: 32px;
        height: 32px;
    }
    &.show {
        z-index: 1000;
        opacity: 1;
        bottom: 30px;
    }

    z-index: -1;
    transition: all .3s;
    opacity: 0;
    position: fixed;
    bottom: -30px;
    right: 10px;
    background-color: #ffffff;
    height: 550px;
    max-width: 350px;
    width: 350px;
    border-radius: 5px;
    box-shadow: 0px 7px 10px 3px rgba(0, 0, 0, 0.5);
    .contact-widget-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        background-color: rgb(229, 74, 103) !important;
        color: #ffffff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        // box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
    }
    .contact-widget-body {
        padding-top: 20px;
        padding-bottom: 20px;
        height: calc(100% - 100px);
        overflow-y: auto;
        background-color: #ffffff;
        &::-webkit-scrollbar {
            width: 10px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
            // background: #f1f1f1;
            border-radius: 5px;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
            background: #f1f1f1;
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
            background: #f1f1f1;
        }
        .form-widget {
            label {
                &.required {
                    position: relative;
                    &::after {
                        content: "*";
                        position: absolute;
                        right: -10px;
                    }
                }
            }
            input, textarea {
                background-color: $colorNeutralN200;
                box-sizing: border-box;
                border-radius: 4px;
                font-size: 16px;
                line-height: 24px;
                font-weight: normal;
                font-style: normal;

                &:focus {
                    outline: unset !important;
                    box-shadow: unset !important;
                    border: 2px solid $colorNeutralN800;
                }
                &:disabled {
                    background-color: $colorBgTertiary;
                }

                &.is-success {
                    background-color:  rgba(219, 239, 220, 0.5);
                    border: 2px solid $colorBorderStatePositive;
                }

                &.has-error {
                    background: rgba(246, 213, 213, 0.5);
                    border: 2px solid $colorBorderStateNegative;
                }
            }

            input {
                height: 48px;
                padding: 12px;
            }

            textarea {
                height: 144px;
            }
        }
    }
    .contact-widget-footer {
        padding: 10px 10px;
        border-top: 1px solid #000;
        background-color: #ffffff;
        text-align: right;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
}
</style>
